import React from 'react'
import { FullBlockLoader, CircleLoader } from '@deal/components'
import { EngagementChannelCategoryFragment } from '#src/generated/graphql'
import ContentfulQuery from '#src/containers/Contentful'
import GradientTakeover from '../GradientTakeover'
import { ContentfulResponse } from './schema'
import styles from './styles.css'

interface Props {
  contentfulVariationSlug: string
  category: EngagementChannelCategoryFragment
  onDismissModal: (trackDismiss: boolean, setCookie: boolean) => void
  onSubmitModal: () => void
}

const V1: React.SFC<Props> = ({
  category,
  contentfulVariationSlug,
  onSubmitModal,
  onDismissModal
}) => {
  const fullPageTakeoverImage = category.contentAssets.fullPageTakeover
    ? category.contentAssets.fullPageTakeover.imageUrl
    : null

  return (
    <ContentfulQuery template="engagementModal" variation={contentfulVariationSlug}>
      {({ loading, content }: ContentfulResponse) => {
        if (loading) {
          return <FullBlockLoader loader={CircleLoader} />
        } else if (content) {
          return (
            <GradientTakeover
              fullPageTakeoverImage={fullPageTakeoverImage}
              header={content.header}
              onSubmitModal={onSubmitModal}
              categorySlug={category.slug}
              buttonText={content.buttonText}
              questions={content.questions}
              onDismissModal={() => onDismissModal(true, true)}
              dismissButtonText={content.dismissButtonText}
              dissmissButtonPlacement="top"
              questionsTitle={content.questionsTitle}
              small
              className={styles.content}
            />
          )
        }

        /**
         * In the event there isn't content set up for the engagement modal for this
         * category we want to set the cookie. We don't want the module to popup if
         * they switch to a category that has a contentful entry.
         */
        onDismissModal(false, false)

        return null
      }}
    </ContentfulQuery>
  )
}

export default V1
